import AppCatalog from "../../services/App/AppCatalog.js";

export default {
  Total: {
    Label: AppCatalog.Field.Total.Label,
    Type: AppCatalog.Field.Hpp.Type,
    Output: AppCatalog.Field.Hpp.Output,
    ReadOnly: true
  }
}